import { StripePaymentControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 *
 * @param isPublic when the caller runs on an unauthenticated page (the open
 * intake-form link) there is no access token in sessionStorage, so sending the
 * empty bearer header 401s. Same handling as the public intake-form endpoints:
 * drop the configuration entirely and let the BE serve the request anonymously.
 */
export const usePatientAttachPaymentMethod = (isPublic?: boolean) =>
  useMutationWithLoading(
    async (params: {
      patientUuid: string;
      paymentMethodId: string;
      isPrimary?: boolean;
      xTENANTID?: string;
    }) =>
      new StripePaymentControllerApi(
        isPublic ? undefined : getConfigObject()
      ).attachPaymentMethodToCustomer(
        params?.patientUuid,
        params?.paymentMethodId,
        params?.isPrimary,
        params?.xTENANTID
      )
  );
